/**
 * Prolon Benefit Card - Expandable with View Transition API
 * Handles card expansion to span 2 columns x 2 rows in grid
 */

(function() {
  'use strict';
  
  let expandedCard = null;
  const MOBILE_BREAKPOINT = 768;

  /**
   * Check if current viewport is mobile
   */
  function isMobile() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  /**
   * Initialize all benefit cards
   */
  function initBenefitCards() {
    const wrappers = document.querySelectorAll('.benefit-card-wrapper');
    
    wrappers.forEach((wrapper, index) => {
      const card = wrapper.querySelector('.prolon-benefit-card');
      if (!card) return;
      
      const hasContent = card.dataset.hasContent === 'true';
      if (!hasContent) return;
      
      // Auto-expand all cards on mobile
      if (isMobile()) {
        wrapper.classList.add('expanded');
        // Don't add click listener on mobile
        return;
      }
      
      // Auto-expand cards with open_by_default_desktop on desktop
      if (card.dataset.openDesktop === 'true' && !expandedCard) {
        wrapper.classList.add('expanded');
        expandedCard = wrapper;
      }

      // Add click listener to the card (desktop only)
      card.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        toggleCard(wrapper, index);
      });
    });
  }

  /**
   * Toggle card expansion with View Transition API (following HTML example pattern)
   */
  function toggleCard(wrapper, index) {
    // Double-check: should never be called on mobile
    if (isMobile()) {
      return;
    }
    
    // Use View Transition API if supported
    if (!document.startViewTransition) {
      // Fallback for browsers without View Transition API
      expand(wrapper);
      return;
    }
    
    // Use View Transitions API for smooth morph effect
    document.startViewTransition(() => {
      expand(wrapper);
    });
  }

  /**
   * Expand/collapse card (simple pattern from HTML example)
   */
  function expand(clickedWrapper) {
    const isCurrentlyExpanded = clickedWrapper.classList.contains("expanded");
    
    // Remove expanded from all cards
    document.querySelectorAll(".benefit-card-wrapper").forEach((wrapper) => {
      wrapper.classList.remove("expanded");
    });

    // Add expanded to the clicked card (if it wasn't already expanded)
    if (!isCurrentlyExpanded) {
      clickedWrapper.classList.add("expanded");
      expandedCard = clickedWrapper;
    } else {
      expandedCard = null;
    }
  }

  /**
   * Handle window resize - collapse all cards on desktop, expand all on mobile
   */
  window.addEventListener('resize', () => {
    const wrappers = document.querySelectorAll('.benefit-card-wrapper');
    
    if (isMobile()) {
      // Expand all cards on mobile
      wrappers.forEach((wrapper) => {
        const card = wrapper.querySelector('.prolon-benefit-card');
        if (card && card.dataset.hasContent === 'true') {
          wrapper.classList.add('expanded');
        }
      });
    } else {
      // Collapse all cards on desktop and re-initialize click handlers
      wrappers.forEach((wrapper) => {
        wrapper.classList.remove("expanded");
      });
      expandedCard = null;
      // Re-initialize to attach click handlers after resize to desktop
      setTimeout(initBenefitCards, 100);
    }
  });

  /**
   * Handle escape key to close all expanded cards (desktop only)
   */
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && expandedCard && !isMobile()) {
      document.querySelectorAll(".benefit-card-wrapper").forEach((wrapper) => {
        wrapper.classList.remove("expanded");
      });
      expandedCard = null;
    }
  });

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBenefitCards);
  } else {
    initBenefitCards();
  }

  // Re-initialize on Shopify section load (for theme editor)
  document.addEventListener('shopify:section:load', initBenefitCards);
  
})();
